import { CollectiviteApi } from '../../api/Collectivite';
import { LiensEsagType } from '../../api/Collectivite/types';
import { ResponseGetAllType } from '../../api/response';

export const LiensActions = {
    getLiens: async (identifiantEntite: number): Promise<ResponseGetAllType<LiensEsagType>> => {
    let liensEsag: ResponseGetAllType<LiensEsagType>;

    try {
      liensEsag = await CollectiviteApi.loadLiensEsag(identifiantEntite || 0);
      return liensEsag;
    } catch (error) {
      console.error('Error fetching liens:', error);
      return null as unknown as ResponseGetAllType<LiensEsagType>; // Ou gérer l'erreur de manière appropriée
    }
  },
}
